import React from 'react';
import styled from 'styled-components';
import { COLORS, SIZES } from '../styleVars';
import { Typography } from '../typography/Typography';
var LoadingContainer = styled.div.withConfig({
  componentId: "sc-12321v4-0"
})(["visibility:", ";padding:", ";height:", ";background-color:", ";"], function (props) {
  return !props.visible ? 'hidden' : 'visible';
}, function (props) {
  return !props.visible ? 0 : "".concat(SIZES['16'], " 0");
}, function (props) {
  return !props.visible ? 0 : 'auto';
}, function (props) {
  return props.bgColor ? COLORS.white : 'none';
});
var LoadingMessage = styled(Typography).withConfig({
  componentId: "sc-12321v4-1"
})(["width:100%;display:flex;justify-content:center;text-align:center;"]);
var Wrapper = styled.div.withConfig({
  componentId: "sc-12321v4-2"
})(["height:", ";display:flex;justify-content:center;"], SIZES['42']);
var Bouncer = styled.div.withConfig({
  componentId: "sc-12321v4-3"
})(["height:", ";width:", ";animation:bounce 0.5s;animation-direction:alternate;animation-timing-function:cubic-bezier(0.5,0.05,1,0.5);animation-iteration-count:infinite;@keyframes bounce{0%{transform:translate3d(0,0,0);}100%{transform:translate3d(0,", ",0);}}"], SIZES['16'], SIZES['16'], SIZES['24']);
var Svg = styled.svg.withConfig({
  componentId: "sc-12321v4-4"
})(["fill:currentColor;width:1em;height:1em;display:inline-block;font-size:", ";color:", ";flex-shrink:0;animation:spin 2s linear infinite;@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}"], SIZES[16], COLORS.fupaSecondary);

var LoadingIndicator = function LoadingIndicator(_ref) {
  var message = _ref.message,
      bgColor = _ref.bgColor,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? true : _ref$isVisible,
      className = _ref.className;
  var LoadingIndicator = /*#__PURE__*/React.createElement(Bouncer, null, /*#__PURE__*/React.createElement(Svg, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.16 10.14L16.37 5.54L12.46 1.89L6.99 3.85L7.17 9L13.16 10.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.07 19.47L14.02 22.54L19.16 20.34L20 15.8L14.89 15.17L11.07 19.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.57 0.27L15.79 0.61L16.95 1.07L18.05 1.64L19.09 2.31L20.04 3.09L20.91 3.96L21.68 4.91L22.36 5.94L22.93 7.04L23.39 8.21L23.72 9.42L23.93 10.69L24 12L23.93 13.31L23.72 14.57L23.39 15.79L22.93 16.95L22.36 18.05L21.68 19.09L20.91 20.04L20.04 20.91L19.09 21.68L18.05 22.36L16.95 22.93L15.79 23.39L14.57 23.72L13.31 23.93L12 24L10.99 23.96L10.01 23.83L9.05 23.63L8.12 23.36L7.23 23.01L6.37 22.6L5.55 22.12L4.78 21.58L4.05 20.98L3.37 20.33L2.74 19.63L2.17 18.88L1.66 18.08L1.21 17.25L0.82 16.37L0.76 16.29L0.76 16.21L0.67 15.95L0.58 15.68L0.49 15.41L0.42 15.14L0.34 14.87L0.28 14.59L0.22 14.31L0.17 14.03L0.12 13.75L0.09 13.46L0.05 13.17L0.03 12.88L0.01 12.59L0 12.29L0 12L0.07 10.69L0.27 9.42L0.61 8.21L1.07 7.04L1.64 5.94L2.31 4.91L3.09 3.96L3.96 3.09L4.91 2.31L5.94 1.64L7.04 1.07L8.21 0.61L9.42 0.27L10.69 0.07L12 0L13.31 0.07L14.57 0.27ZM10.96 0.67L10.45 0.73L9.95 0.81L9.46 0.91L8.97 1.03L8.49 1.18L8.02 1.34L7.57 1.53L7.12 1.73L6.68 1.95L6.25 2.19L5.83 2.45L5.43 2.72L5.04 3.01L4.3 4.19L1.46 7.71L1.36 7.98L1.26 8.25L1.17 8.52L1.08 8.8L1.01 9.08L0.94 9.36L0.87 9.64L0.81 9.93L0.76 10.22L0.72 10.51L0.69 10.8L0.66 11.1L0.64 11.4L0.63 11.7L0.62 12L0.62 12.14L0.63 12.29L0.63 12.43L0.64 12.58L0.65 12.72L0.66 12.86L0.67 13.01L0.68 13.15L0.7 13.29L0.72 13.43L0.73 13.57L0.76 13.71L0.78 13.85L0.8 13.99L0.83 14.13L0.9 11.71L4.2 12.84L6.31 18.27L4.1 20.17L4.52 20.56L4.96 20.92L5.41 21.26L5.89 21.58L6.38 21.88L6.88 22.15L7.4 22.4L7.94 22.62L8.48 22.82L9.04 22.98L9.61 23.12L10.2 23.23L10.79 23.31L11.39 23.36L12 23.37L13.21 23.31L14.39 23.12L15.53 22.81L16.61 22.39L17.64 21.87L18.61 21.25L19.5 20.54L20.32 19.74L21.06 18.86L21.71 17.92L22.26 16.9L22.7 15.83L23.04 14.71L23.26 13.54L23.36 12.34L22.19 12.04L20.35 6.85L20.82 4.82L20.57 4.53L20.32 4.25L20.05 3.98L19.78 3.71L19.5 3.45L19.21 3.21L18.91 2.97L18.6 2.74L18.29 2.53L17.97 2.32L17.64 2.13L17.3 1.94L16.96 1.77L16.61 1.6L16.25 1.45L13.46 1.1L12.19 0.63L12.17 0.63L12.16 0.63L12.15 0.63L12.12 0.63L12.07 0.63L12.05 0.62L12.04 0.62L12.02 0.62L12.01 0.62L12 0.62L11.48 0.64L10.96 0.67Z"
  })));

  if (message) {
    return /*#__PURE__*/React.createElement(LoadingContainer, {
      visible: isVisible,
      bgColor: bgColor
    }, /*#__PURE__*/React.createElement(Wrapper, null, LoadingIndicator), /*#__PURE__*/React.createElement(LoadingMessage, {
      variant: "caption1"
    }, message));
  }

  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className
  }, LoadingIndicator);
};

export { LoadingIndicator };
//# sourceMappingURL=LoadingIndicator.js.map